var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBackImageCard2(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 94,
    height: 90,
    viewBox: "0 0 94 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M85.3333 82H7.83331M7.83331 39.375L23.5774 26.7812M85.3333 39.375L53.8451 14.1875C51.7839 12.5387 49.2229 11.6404 46.5833 11.6404C43.9438 11.6404 41.3828 12.5387 39.3216 14.1875L36.2913 16.6094M60.1458 18.0625V10.3125C60.1458 9.79864 60.3499 9.30583 60.7133 8.94248C61.0767 8.57913 61.5695 8.375 62.0833 8.375H71.7708C72.2847 8.375 72.7775 8.57913 73.1408 8.94248C73.5042 9.30583 73.7083 9.79864 73.7083 10.3125V29.6875M15.5833 82V33.5625M77.5833 33.5625V49.0625M77.5833 82V64.5625",
    stroke: "#0A3764",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M58.2083 82V62.625C58.2083 57.1457 58.2083 54.4061 56.5033 52.705C54.8061 51 52.0664 51 46.5833 51C41.1002 51 38.3644 51 36.6633 52.705M34.9583 82V62.625",
    stroke: "#0A3764",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M54.3333 33.5625C54.3333 35.6179 53.5168 37.5892 52.0634 39.0426C50.61 40.496 48.6387 41.3125 46.5833 41.3125C44.5279 41.3125 42.5566 40.496 41.1032 39.0426C39.6498 37.5892 38.8333 35.6179 38.8333 33.5625C38.8333 31.5071 39.6498 29.5358 41.1032 28.0824C42.5566 26.629 44.5279 25.8125 46.5833 25.8125C48.6387 25.8125 50.61 26.629 52.0634 28.0824C53.5168 29.5358 54.3333 31.5071 54.3333 33.5625Z",
    stroke: "#0A3764",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackImageCard2);
export default __webpack_public_path__ + "static/media/back_image_card_2.d9ed4eeff10ebb27ace02f8185efbfa7.svg";
export { ForwardRef as ReactComponent };